<script>
/**
 * @overview 课时详情 - 复习编辑弹窗
 *
 * @author huojinzhao
 */

import mapUtils, { $http } from "@/utils";
import draggable from "vuedraggable";
import MenuItem from '../../../components/MenuItem/index.vue';
import * as gameManageServer from '../../../api/gameManage';

export default {
  name: "CourseDetailReview",
  components: {
    draggable,
    MenuItem,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },

  data: () => ({
    menusData: [], // 菜单所有数据
    menu: [], // 一级菜单
    menuSelect: '', // 一级菜单选中值
    menuTwo: [], // 二级菜单
    menuTwoSelect: '', // 二级菜单选中值

    searchInput: "",
    searchSelect: "name",
    loading: {
      init: false,
      fetch: false,
      submit: false,
    },

    list: {
      data: [],
    },

    review: [],

    query: {
      page: 1,

      per_page: 10,

      "like[name]": "",

      "equal[type]": null,
    },
  }),

  computed: {
    types() {
      return this.$store.state.game.types;
    },
  },

  created() {
    this.init();

    this.query["equal[type]"] = this.types[0].value;

    this.gameFetchList();
  },

  methods: {
    ...mapUtils("list", ["fetch", "routeQuery"]),

    ...mapUtils("form", ["submit", "errorAlert"]),

    async init() {
      try {
        const res = await gameManageServer.queryGameTypes();
        this.menusData = res.game_types;
        // 一级分类
        this.menu = res.game_types.map(v => ({
          id: v.type_id,
          value: v.name,
        }));
        this.menuSelect = this.menu && this.menu[0] && this.menu[0].id;
        // 二级分类
        this.menusData.map((v) => {
          if (v.type_id === this.menuSelect) {
            this.menuTwo = v.leaf && v.leaf.map(q => ({
              id: q.type_id,
              value: q.name,
            }));
          }
        });
        this.menuTwoSelect = this.menuTwo && this.menuTwo[0] && this.menuTwo[0].id;

        this.loading.init = true;
      } catch (e) {
        console.log('err==>', e);
      }

      return $http.get(`/review/show/${this.id}`)
        .then(({ games = [] }) => {
          this.review = games;
        })
        .finally(() => {
          this.loading.init = false;
        });
    },

    reviewCheckout(id) {
      return this.review.some(item => item.id === id);
    },

    reviewCheckin(value, game) {
      const list = value
        ? [...this.review, game]
        : this.review.filter(item => item.id !== game.id);

      this.review = list;
    },

    gameFetchList() {
      this.loading.fetch = true;

      const query = this.$list_routeQuery(this.query, {});

      return this.$list_fetch("/game", query)
        .then((res) => {
          this.list = res;
        })
        .finally(() => {
          this.loading.fetch = false;
        });
    },

    queryPage(value) {
      this.query.page = value;

      this.gameFetchList();
    },

    // 一级分类选中
    queryTypeOne(e, initial = false) {
      try {
        this.menuSelect = e;
        // 获取二级分类
        this.menusData.map((v) => {
          if (`${v.type_id}` === `${e}`) {
            this.menuTwo = v.leaf && v.leaf.map(q => ({
              id: q.type_id,
              value: q.name,
            }));
          }
        });
        if (!initial) {
          this.menuTwoSelect = this.menuTwo && this.menuTwo[0].id;
        }
        this.menuTwoSelect && this.queryType(this.menuTwoSelect);
      } catch (err) {
        console.log('一级分类选中失败==>', err);
      }
    },

    queryType(value) {
      this.menuTwoSelect = value;
      this.query["equal[type]"] = value;
      this.query["like[name]"] = "";

      this.gameFetchList();
    },

    queryName() {
      switch (this.searchSelect) {
        case "name":
          this.query = { ...this.query, "like[name]": this.searchInput, "like[game_pack_name]": "" };
          break;
        case "game_pack_name":
          this.query = { ...this.query, "like[name]": "", "like[game_pack_name]": this.searchInput };
          break;
      }
      this.gameFetchList();
    },

    submit() {
      this.loading.submit = true;

      const game_ids = this.review.map(item => item.id);

      const data = { game_ids };

      const uri = `/review/${this.id}`;

      this.$form_submit({ uri, data })
        .then(() => this.$emit("success"))
        .catch(this.$form_errorAlert)
        .finally(() => {
          this.loading.submit = false;
        });
    },

    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<template>
  <div
    v-loading="loading.fetch || loading.init"
    class="course-detail-review"
  >
    <div class="course-detail-review__header">
      <div>
        <menu-item
          :data="menu"
          :value="menuSelect"
          @change="queryTypeOne"
        />
        <menu-item
          :data="menuTwo"
          :value="menuTwoSelect"
          @change="queryType"
        />
      </div>
      <el-input
        v-model="searchInput"
        placeholder="请输入内容"
        class="input-with-select">
        <el-select
          slot="prepend"
          v-model="searchSelect"
          class="search_select"
          placeholder="请选择">
          <el-option
            label="名称"
            value="name"/>
          <el-option
            label="游戏包"
            value="game_pack_name"/>
        </el-select>
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="queryName"/>
      </el-input>
    </div>

    <div class="course-detail-review__body">
      <div class="course-detail-review__value">
        <draggable
          v-model="review"
          :options="{ group: 'people' }"
          @start="drag = true"
          @end="drag = false">
          <el-tag
            v-for="item in review"
            :key="item.id"
            class="review_tag"
            closable
            @close="() => reviewCheckin(false, item)"
          >
            {{ item.type_name }} : {{ item.name }}
          </el-tag>
        </draggable>
      </div>

      <el-table
        :data="list.data"
        class="course-detail-review__table"
      >
        <el-table-column
          :index="index => index + 1"
          align="center"
          width="100px"
          type="index"
          label="序号"
        />
        <el-table-column
          label="名称"
          prop="name"
        />
        <el-table-column
          label="游戏包名称"
          prop="game_pack_name"
        />
        <el-table-column
          label="制作日期"
          prop="create_date"
        />
        <el-table-column
          align="center"
          width="100px"
          label="操作"
        >
          <template slot-scope="{ row }">
            <el-checkbox
              :value="reviewCheckout(row.id)"
              @change="value => reviewCheckin(value, row)"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <AppPagination
      :list="list"
      :size="query.per_page"
      @changeIndex="queryPage"
    />

    <AppFormSubmit
      :submitting="loading.submit"
      @submit="submit"
      @cancel="cancel"
    />
  </div>
</template>

<style lang="postcss" scoped>
.search_select{
  width: 90px;
}
.course-detail-review {
  flex-direction: column;
  display: flex;
  /*height: 700px;*/
  height: auto;
}

.course-detail-review__header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--bd-color-default);
  padding-bottom: 1.5em;
  margin-bottom: 1.5em;
}

.course-detail-review__header .el-input-group {
  width: auto;
}

.course-detail-review__body {
  display: flex;
  flex: auto;
}

.course-detail-review__value {
  flex: none;
  display: flex;
  flex-direction: column;
  width: 200px !important;
  padding-right: 1em;
  margin-right: 1em;
  border-right: 1px solid var(--bd-color-default);
}

.course-detail-review__value > :not(:last-child) {
  margin-bottom: 6px;
}

.course-detail-review__value .el-tag {
  display: flex;
  align-items: center;
}

.course-detail-review__value .el-tag__close {
  margin-left: auto;
  margin-bottom: -2px;
  padding-top: 1px;
}

.course-detail-review__table {
  flex: auto;
}

/* 取出el-table append时的下边 */
.course-detail-review__table.el-table::before {
  background-color: transparent;
}
.search_select .el-input {
  width: 100px !important;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.review_tag{
  cursor: move;
  margin-bottom: 6px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block !important;
  position: relative;
}
.review_tag >>> .el-tag__close{
  position: absolute;
  right: 2px;
  top: 8px;
}
</style>
